import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Auth from '../components/Auth';
import Nav from '../components/Nav';
import '../css/Documentacion.css';

function Documentacion() {
  const [documentacionData, setDocumentacionData] = useState([]);
  const [documentacion, setDocumentacion] = useState('');
  const [message, setMessage] = useState('');
  const [cursos, setCursos] = useState([]);
  const [documentacionAsignada, setdocumentacionAsignada] = useState([]);
  const [cursoSeleccionado, setcursoSeleccionado] = useState(null);
  const [IdcursoSeleccionado, setIdcursoSeleccionado] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  console.log(documentacionAsignada);

  useEffect(() => {
    descargardocumentacion();
    descargarcursos();
    if (cursoSeleccionado) {
      obtenerOpcionesAsignadas(cursoSeleccionado);
    }
  }, [cursoSeleccionado]);

  async function descargardocumentacion() {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/docu/buscar`);
      const data = response.data;
      setDocumentacionData(data);
    } catch (error) {
      console.error('Error al obtener la documentación:', error);
    }
  }

  async function descargarcursos() {
    try {
      const responseCursos = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/curso/buscar`);
      const cursosData = responseCursos.data;
      setCursos(cursosData);
    } catch (error) {
      console.error('Error al obtener los cursos:', error);
    }
  }

  async function obtenerOpcionesAsignadas(cursoId) {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/curso/buscar/${cursoId}`);
      const cursoSeleccionado = response.data;
      console.log('id', response.data.id_curso);
      setIdcursoSeleccionado(response.data.id_curso);
      console.log('curso seleccionado', response.data);
      if (cursoSeleccionado.docu_id) {
        const opcionesAsignadas = JSON.parse(cursoSeleccionado.docu_id);
        setdocumentacionAsignada(opcionesAsignadas);
      } else {
        setdocumentacionAsignada([]);
      }
    } catch (error) {
      console.error('Error al obtener las opciones asignadas:', error);
    }
  }

  async function creardocumentacion() {
    if (!documentacion.trim()) {
      setMessage('El nombre de la documentación no puede estar vacío');
      return;
    }
  
    const docuData = {
      documentacion: documentacion,
    };
  
    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/docu`, docuData);
      setMessage('Documentación creada correctamente');
      resetFormulario();
      descargardocumentacion();
    } catch (error) {
      console.error('Error al crear la documentación:', error);
      setMessage('Error al crear la documentación');
    }
  }

  const resetFormulario = () => {
    setDocumentacion('');
  };

  async function asignarDocumentacion() {
    if (!cursoSeleccionado) {
      alert('Selecciona un curso');
      return;
    }

    try {
      const requestData = {
        id_curso: IdcursoSeleccionado,
        docu_id: documentacionAsignada,
      };

      console.log('Datos a enviar:', requestData);

      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/curso/editar`,
        requestData,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      setcursoSeleccionado(null);
      alert('Documentación vinculada correctamente');
      window.location.reload();
    } catch (error) {
      console.error('Error al vincular la documentación al curso:', error);
      alert('Error al vincular la documentación al curso');
    }
  }

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredCursos = cursos.filter(curso =>
    curso.nombre.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Auth>
      {({ nombreUsuario, isAdmin }) => (
        <div>
          <Nav />
          <div className='documentacion-container'>
            <h3>Bienvenido {nombreUsuario}</h3>
            <h1>Gestión de tipos de documentación para cursos</h1>
            <div className='documentacion-form'>
              <label className='documentacion-tituloDocu' htmlFor='curso'>
                Selecciona un curso:
              </label>
              <div className='documentacion-dropdown'>
                <input
                  type='text'
                  placeholder='Buscar curso...'
                  value={searchTerm}
                  onChange={handleSearchChange}
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  className='documentacion-dropdown-input'
                />
                {isDropdownOpen && (
                  <div className='documentacion-dropdown-menu'>
                    {filteredCursos.length > 0 ? (
                      filteredCursos.map(curso => (
                        <div
                          key={curso.wp_id}
                          className='documentacion-dropdown-item'
                          onClick={() => {
                            setcursoSeleccionado(curso.wp_id);
                            setSearchTerm(curso.nombre); // Muestra el nombre del curso en el input
                            setIsDropdownOpen(false);
                          }}
                        >
                          {curso.nombre}
                        </div>
                      ))
                    ) : (
                      <div className='documentacion-dropdown-item'>No se encontraron cursos</div>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className='documentacion-form'>
              <label className='documentacion-tituloDocu'>Selecciona opciones de documentación:</label>
              <ul>
                {documentacionData.map(documentacionItem => (
                  <li key={documentacionItem.id_docu}>
                    <label>
                      <input
                        type='checkbox'
                        checked={documentacionAsignada.includes(documentacionItem.id_docu)}
                        onChange={() => {
                          const updatedDocumentacion = documentacionAsignada.includes(documentacionItem.id_docu)
                            ? documentacionAsignada.filter(id => id !== documentacionItem.id_docu)
                            : [...documentacionAsignada, documentacionItem.id_docu];
                          setdocumentacionAsignada(updatedDocumentacion);
                        }}
                      />
                      {documentacionItem.documentacion}
                    </label>
                  </li>
                ))}
              </ul>
              <button onClick={asignarDocumentacion} className='documentacion-button'>
                Asignar Documentación
              </button>
            </div>
            <div className='documentacion-form'>
              <label className='documentacion-tituloDocu'>Crear nueva documentación:</label>
              <input
                className='documentacion-inputDocu'
                type='text'
                value={documentacion}
                onChange={(e) => setDocumentacion(e.target.value)}
                placeholder='Ingrese el nombre de la documentación'
              />
              <button onClick={creardocumentacion} className='documentacion-button'>
                Crear Documentación
              </button>
            </div>
            <p className='documentacion-message'>{message}</p>
          </div>
        </div>
      )}
    </Auth>
  );
  
}

export default Documentacion;
